module.exports = __webpack_public_path__ + "static/weJay1-abb1c846096de1d71d5325dcf35a545a.png";